<template>
  <div class="relative inline-flex items-center justify-center">
    <!-- Battery SVG -->
    <svg
      :width="size"
      :height="size * (23 / 38)"
      viewBox="0 0 38 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 0C33.3137 3.86554e-07 36 2.68629 36 6V7C37.1046 7 38 7.89543 38 9V14C38 15.0357 37.2128 15.887 36.2041 15.9893L36 16V17C36 20.3137 33.3137 23 30 23H6C2.68629 23 0 20.3137 0 17V6C0 2.68629 2.68629 9.66384e-08 6 0H30Z"
        :fill="`url(#battery_gradient_${uid})`"
      />
      <defs>
        <linearGradient
          :id="`battery_gradient_${uid}`"
          x1="38"
          y1="11.5"
          x2="0"
          y2="11.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop :stop-color="batteryColor[0]" />
          <stop offset="1" :stop-color="batteryColor[1]" />
        </linearGradient>
      </defs>
    </svg>

    <!-- Flash SVG (Centered) -->
    <div v-if="charging" class="absolute inset-0 flex items-center justify-center">
      <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          id="Vector"
          d="M6.53922 0.347815C7.17551 -0.182425 8.1221 -0.0968447 8.6525 0.539221C9.18274 1.17551 9.09716 2.1221 8.4611 2.6525L5.64469 5.00016H7.50016C8.13169 5.00016 8.69533 5.39658 8.91031 5.99039C9.12486 6.58387 8.94577 7.24833 8.4611 7.6525L2.4611 12.6525C1.82481 13.1827 0.878221 13.0972 0.347815 12.4611C-0.182425 11.8248 -0.0968447 10.8782 0.539221 10.3478L3.35563 8.00016H1.50016C0.868628 8.00016 0.304991 7.60373 0.0900022 7.00992C-0.12454 6.41645 0.054543 5.75198 0.539221 5.34781L6.53922 0.347815Z"
          class="fill-black-white"
        />
      </svg>
    </div>

    <!-- Percentage (Centered when not charging) -->
    <div
      v-else
      class="absolute inset-0 mr-0.5 bottom-px flex items-center justify-center font-[Barlow] text-l-bold text-black-white select-none"
      style="-webkit-text-stroke: initial"
    >
      {{ percentage }}
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { v4 as uuidv4 } from 'uuid'

  interface Props {
    percentage?: number // 0-100
    charging?: boolean
    size?: number
  }

  const props = withDefaults(defineProps<Props>(), {
    percentage: 100,
    charging: false,
    size: 38,
  })

  // Generate a unique ID using uuid
  const uid = uuidv4()

  const batteryColor = computed(() => {
    // 充电状态下颜色保持原色（根据需求描述："当充电状态时...battery.svg为原本颜色"）
    // 或者当不在充电状态时根据电量变化
    if (props.charging) {
      return ['#5CE196', '#30B002']
    }

    const p = props.percentage
    if (p >= 50) {
      return ['#5CE196', '#30B002']
    } else if (p >= 30) {
      return ['#FFF0C8', '#FF930C']
    } else {
      return ['#FFB7EA', '#F54180']
    }
  })
</script>

<style lang="scss" scoped></style>
